import { render, staticRenderFns } from "./data_detail.vue?vue&type=template&id=b19b20b4&scoped=true"
import script from "./data_detail.vue?vue&type=script&lang=js"
export * from "./data_detail.vue?vue&type=script&lang=js"
import style0 from "./data_detail.vue?vue&type=style&index=0&id=b19b20b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19b20b4",
  null
  
)

export default component.exports